import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { EventsRoutingModule } from './events-routing.module';
import { EventsComponent } from './events.component';
import { MyDatePickerModule } from 'mydatepicker';
@NgModule({
    declarations: [
        EventsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        NgSelectModule,
        NgxUiLoaderModule,
        MaskedTextBoxModule,
        EventsRoutingModule,
        MyDatePickerModule

    ],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
    exports:[EventsComponent],
})
export class EventsModule { }
